import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../../models/workflow/workflow.model';
import { WorkflowRegistry } from '../../../../services/workflow.service';
import { ElementValueSettings, ElementValueSettingsDataHelper } from '../elemValue/elemValue.settings';

export class RemoveFromDataSourceModulExecuter extends WorkflowModuleExecuter {

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'removeFromDataSourceModule';
        reg.Caption = '@@Wert aus Liste entfernen';
        reg.SettingsControl = ElementValueSettings;
        reg.SettingsTypeHelper = new ElementValueSettingsDataHelper();
        reg.Executer = RemoveFromDataSourceModulExecuter;
        reg.GroupID = 'layout';
        reg.Index = 40;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    async execute(status: WorkflowStatus): Promise<number> {
        if (status.ActualParameter) {
            if (status.ActualSettings) {
                if (typeof status.ActualSettings.ElemName === 'string') {
                    const elem = status.WorkflowLayoutService.getElementByName(status.ActualSettings.ElemName);
                    if (elem) {
                        if (elem.Element) {
                            const ds = elem.Element.DataSource;
                            if (Array.isArray(ds)) {
                                const index = ds.indexOf(status.ActualParameter);
                                if (index < 0) {
                                    status.Logger.logError('RemoveFromDataSource modul: DataSource does not contain element.');
                                } else {
                                    ds.splice(index, 1);
                                    elem.Element.DataSource = ds;
                                    return 0;
                                }
                            } else {
                                status.Logger.logError('RemoveFromDataSource modul: DataSource not of type array.');
                            }
                        } else {
                            status.Logger.logError('RemoveFromDataSource modul: Control not found.');
                        }
                    } else {
                        status.Logger.logError('RemoveFromDataSource modul: Element not found.');
                    }
                } else {
                    status.Logger.logError('RemoveFromDataSource modul: No element name found.');
                }
            } else {
                status.Logger.logError('RemoveFromDataSource modul: No settings found.');
            }
        } else {
            status.Logger.logError('RemoveFromDataSource modul: No element found to remove.');
        }
        return super.execute(status);
    }
}
